import React from 'react';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from './../layout/Dashboard';
import { FormattedMessage } from 'react-intl';
import { Messages } from "../../components/layout/Messages/Messages";
import { NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS } from '../../config/notifications';
import { CreateEmailCampaignForm } from "../../components/pages/emailCampaigns/createEmailCampaign/CreateEmailCampaignForm";
import { history } from '../../store/store';
import { ROUTE_CLIENT_EMAIL_CAMPAIGNS } from '../../config/routes';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './CreateEmailCampaign.scss';

function CreateEmailCampaignComponent(props) {
  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="create-email-campaign-workspace">
        <PageHeader
          title={<FormattedMessage id="components.pages.emailCampaigns.createEmailCampaign.title"/>}
        />
        <div className="create-email-campaign-notifications">
          <Messages/>
          <Messages notificationId={ NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS } />
        </div>
        <PageSurface className="create-email-campaign-surface">
          <CreateEmailCampaignForm actionCallback={() => history.push( ROUTE_CLIENT_EMAIL_CAMPAIGNS )}/>
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

const mapActionsToProps = { hideNotification };

const CreateEmailCampaign = connect(null, mapActionsToProps)(CreateEmailCampaignComponent);

export { CreateEmailCampaign, CreateEmailCampaignComponent };
